import { BASE_END_POINT } from "../../parametros";
import { RespostaTodasAsComprasSolicitadasDTO } from "../dtos/RespostaTodasAsComprasSolicitadasDTO";
import i18n from "i18next";

async function buscarComprasSolicitadas(
    usuario: string,
    senha: string
): Promise<Array<RespostaTodasAsComprasSolicitadasDTO>> {

    const url = `${BASE_END_POINT}/api-v1/pagamentos/${usuario}/${senha}/compras-solicitadas`;

    const response = await fetch(url, {
        headers: { 'Accept-Language': i18n.language }
    });

    if (!response.ok) {
        throw new Error(`Erro ao buscar compras solicitadas. Código: ${response.status}`);
    }

    return await response.json() as Array<RespostaTodasAsComprasSolicitadasDTO>;
}

export {
    buscarComprasSolicitadas
};
